import { TOAST_TEST_IDS } from '@susu/custom-made/utils/testIds';
import cn from 'classnames';

import Button, { ButtonSize, ButtonType } from '../button/button';
import './toast.css';

export const enum ToastType {
  Regular = 'regular',
  Warning = 'warning',
}

type ToastProps = {
  text: string;
  type: ToastType;
  hasBtn: boolean;
  btnText: string;
  icon: string;
  isHidden: boolean;
  btnClickHandler: () => void;
};

const Toast = ({ text, type, hasBtn, btnText, icon, isHidden = false, btnClickHandler }: ToastProps) => {
  const isWarning = type === ToastType.Warning;
  const iconHolderClasses = cn('w-16 h-16 text-base mr-[9px] flex items-center justify-center', {
    'toast-icon-holder-warning border border-solid border-red-600 rounded-full bg-contain': isWarning,
  });

  return (
    <div
      className={cn(
        'flex items-center text-xs font-medium leading-xs absolute left-1/2 -translate-x-1/2 h-40 bg-white rounded-[80px] pl-16 transition-[opacity,bottom,padding] duration-[400ms] ease-[cubic-bezier(0.5,0.05,0.1,1)]',
        hasBtn ? 'pr-4' : 'pr-16',
        isHidden ? 'opacity-0 -bottom-16' : 'bottom-16',
        { 'text-red-600': isWarning },
      )}
      data-testid={TOAST_TEST_IDS.CONTAINER}
    >
      {icon && icon !== 'alert' && (
        <i className={cn(iconHolderClasses, 'susu-icons')} translate="no">
          {icon}
        </i>
      )}
      {icon === 'alert' && <div className={iconHolderClasses} />}
      <div className="font-medium whitespace-nowrap">{text}</div>
      {hasBtn && btnClickHandler && (
        <div className="ml-20">
          <Button onClick={btnClickHandler} size={ButtonSize.Large} testId={TOAST_TEST_IDS.BTN} type={ButtonType.Warning}>
            {btnText}
          </Button>
        </div>
      )}
    </div>
  );
};

export default Toast;
